// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingAddressesStyles } from "@steiner/Overrides/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

checkoutShippingAddressesStyles.addressContainer = {
    gapMobile: 24,
};

checkoutShippingAddressesStyles.shippingAddressGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${xScreen("lte", 520)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

checkoutShippingAddressesStyles.billingAddressGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${xScreen("lte", 520)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};
